import { ROLE } from "@kalyzee/kast-web-sdk/http";

export const USER_ROLE_TO_INT = {
  [ROLE.KADMIN] : 0,
  [ROLE.ADMIN]: 1, 
  [ROLE.TECHNICIAN]: 2, 
  [ROLE.ORGANIZER]: 3, 
  [ROLE.ATTENDEE]: 4, 
  [ROLE.GUEST]: 5, 
}

export const compareRoles = (role1: ROLE, role2: ROLE): number => {
  const role1Value = USER_ROLE_TO_INT[role1];
  const role2Value = USER_ROLE_TO_INT[role2];

  if (role1Value < role2Value) {
    return -1;
  } else if (role1Value > role2Value) {
    return 1;
  } else {
    return 0;
  }
};

export const isRoleGreaterThanOrEqual = (role1: ROLE, role2: ROLE): boolean => {
  return compareRoles(role1, role2) <= 0;
};

export const isRoleGreaterThan = (role1: ROLE, role2: ROLE): boolean => {
  return compareRoles(role1, role2) < 0;
};

export const isRoleLessThanOrEqual = (role1: ROLE, role2: ROLE): boolean => {
  return compareRoles(role1, role2) >= 0;
};

export const isRoleLessThan = (role1: ROLE, role2: ROLE): boolean => {
  return compareRoles(role1, role2) > 0;
};